const PERM = {
  noAccess: 'NO_ACCESS',
  read: 'READ_ONLY',
  readEdit: 'READ_EDIT',
  readEditDelete: 'READ_EDIT_DELETE',
};

export default PERM;
